import {request} from '@umijs/max';

/** 登录 */
export async function login(
  body: { username: string; password: string },
  options?: Record<string, any>,
) {
  return request<API.Result<API.LoginData>>('/api/auth/login', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 登出 */
export async function logout(options?: Record<string, any>) {
  return request<API.Result<null>>('/api/auth/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取当前用户信息（GET /api/auth/info） */
export async function getUserInfo(options?: Record<string, any>) {
  return request<API.Result<API.LoginData>>('/api/auth/info', {
    method: 'GET',
    ...(options || {}),
  });
}
